import { format, parseISO } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";

export const isoToDate = isoDate =>
  format(zonedTimeToUtc(isoDate, "America/New_York"), "yyyy-MM-dd");

export const formatToMilitaryDate = val => format(parseISO(val), "dd LLL yyyy");

export const getTotalDays = (date1, date2) =>
  Math.abs(differenceInCalendarDays(date2, date1)) + 1;

export const VA_TAX_RATE = 0.0;
